import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from './reducers/authReducer';
import usersReducer from './reducers/usersReducer';
import groupsReducer from './reducers/groupsReducer';
import aboutReducer from './reducers/aboutReducer';
import contentReducer from './reducers/contentReducer';
import dialogReducer from './reducers/dialogReducer';
import notificationReducer from './reducers/notificationReducer';
import drawerReducer from './reducers/drawerReducer';
import filterReducer from './reducers/filterReducer';
import applicationReducer from './reducers/applicationReducer'
import emailReducer from './reducers/emailReducer';
import prndReducer from './reducers/prndReducer';
import esriReducer from './reducers/esriReducer';
import documentReducer from './reducers/documentReducer';
import adminNotificationReducer from './reducers/adminNotificationReducer';
import analyticsReducer from './reducers/analyticsReducer';
import ssoReducer from './reducers/ssoReducer';
import azureReducer from './reducers/azureReducer';
import layerReducer from './reducers/layerReducer';

const rootReducer = combineReducers({
    authReducer,
    usersReducer,
    groupsReducer,
    aboutReducer,
    contentReducer,
    dialogReducer,
    notificationReducer,
    drawerReducer,
    filterReducer,
    applicationReducer,
    emailReducer,
    prndReducer,
    esriReducer,
    documentReducer,
    adminNotificationReducer,
    analyticsReducer,
    ssoReducer,
    azureReducer,
    layerReducer
  });

const persistConfig = {
  key: "root",
  storage,
  whitelist: ['authReducer']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const createStoreWithPersistor = () => {
  let persistor = persistStore(store);
  return { store, persistor };
};

export default createStoreWithPersistor;